exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper--1wpOp {\n  height: 100%;\n  margin: 0;\n}\n\n.main--2v1cV {\n  flex: 1 0 0;\n}\n\n", ""]);

// exports
exports.locals = {
	"wrapper": "wrapper--1wpOp",
	"main": "main--2v1cV"
};